import React from "react";

export default function Field({ label, children }) {
  return (
    <div>
      <label className="block text-xs mb-1.5 color-primary">
        {label}
      </label>
      {children}
    </div>
  );
}
